(function () {
  'use strict';
  var box = document.querySelector('[data-elvi-quiz]');
  if (!box) return;
  var css = '@media(max-width:600px){' +
    '.elvi-scope .elvi-res__grid{display:flex;gap:12px;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;position:relative;padding:4px 14% 6px;margin-left:-16px;margin-right:-16px;overscroll-behavior-x:contain}' +
    '.elvi-scope .elvi-res__grid::-webkit-scrollbar{display:none}' +
    '.elvi-scope .elvi-res__grid{--cw:72%}' +
    '.elvi-scope .elvi-res__grid>.elvi-rc{flex:0 0 var(--cw);max-width:var(--cw);scroll-snap-align:center;scroll-snap-stop:always}' +
    '.elvi-scope .elvi-cnav{display:flex;align-items:center;justify-content:center;gap:18px;margin-top:14px}' +
    '.elvi-scope .elvi-cnav button{width:34px;height:34px;border-radius:50%;border:1px solid rgba(255,255,255,.22);background:transparent;color:rgba(255,255,255,.8);font-size:20px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;transition:opacity .3s,border-color .3s}' +
    '.elvi-scope .elvi-cnav button:disabled{opacity:.25;cursor:default}' +
    '.elvi-scope .elvi-cnav__n{font-size:12px;letter-spacing:.2em;color:rgba(255,255,255,.6);min-width:46px;text-align:center}' +
    '}' +
    '@media(min-width:601px){.elvi-scope .elvi-cnav{display:none}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function enhance(grid) {
    if (grid.getAttribute('data-car')) return;
    grid.setAttribute('data-car', '1');
    var cards = grid.querySelectorAll('.elvi-rc');
    if (cards.length < 2) return;
    var nav = document.createElement('div');
    nav.className = 'elvi-cnav';
    nav.innerHTML = '<button type="button" data-p aria-label="Previous piece">‹</button><span class="elvi-cnav__n" aria-live="polite"></span><button type="button" data-n aria-label="Next piece">›</button>';
    grid.parentNode.insertBefore(nav, grid.nextSibling);
    var prev = nav.querySelector('[data-p]'), next = nav.querySelector('[data-n]'), num = nav.querySelector('.elvi-cnav__n');
    var idx = 0;
    function cur() {
      var mid = grid.scrollLeft + grid.clientWidth / 2, best = 0, d = 1e9;
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i].offsetLeft + cards[i].offsetWidth / 2, dd = Math.abs(c - mid);
        if (dd < d) { d = dd; best = i; }
      }
      return best;
    }
    function upd() {
      idx = cur();
      num.textContent = (idx + 1) + ' / ' + cards.length;
      prev.disabled = idx === 0; next.disabled = idx === cards.length - 1;
    }
    function go(i) {
      i = Math.max(0, Math.min(cards.length - 1, i));
      var c = cards[i];
      grid.scrollTo({ left: c.offsetLeft + c.offsetWidth / 2 - grid.clientWidth / 2, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { go(idx - 1); });
    next.addEventListener('click', function () { go(idx + 1); });
    var t = null;
    grid.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(upd, 60); }, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  function scan() { var g = box.querySelector('.elvi-res__grid'); if (g) enhance(g); }
  new MutationObserver(scan).observe(box, { childList: true, subtree: true });
  scan();
})();